import React from 'react';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import { AppUtils } from '@gscope-mfe/app-bridge';
const { FormControl, Radio, Button, RadioGroup, FormControlLabel, makeStyles } = MaterialUiCore;
import classes from './MarketSelector.module.css';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
    formControlLabelMatUI: {
        '& .MuiTypography-body1': {
            fontSize: '14px',
        },
    },
}));

const MarketSelector = ({ LeftPanelShowToggle }) => {
    const { t } = useTranslation('commonLang');
    const { showMarketDropdown } = AppUtils.get().headerConfig;
    const styles = useStyles();
    const { currentMarket, setCurrentSelectedMarket, permission } = AppUtils.get();

    const [marketChosen, setMarketChosen] = React.useState(currentMarket);
    if (showMarketDropdown && permission && permission.markets && permission.markets.length > 1) {
        return (
            <FormControl variant="outlined" style={{ width: '100%', height: '100%' }} id="marketSelector">
                <RadioGroup
                    aria-label="market"
                    defaultValue={currentMarket}
                    name="radio-buttons-group"
                    onChange={(e) => setMarketChosen(e.target.value)}
                    className={classes.radioGroup}
                    data-testid="markets-list"
                >
                    {permission.markets.sort().map((market) => (
                        <FormControlLabel
                            className={`${classes.formControlLabel} ${styles.formControlLabelMatUI}`}
                            style={{ fontSize: '14px' }}
                            label={t(market) == market ? market.toUpperCase() : t(market)}
                            key={market}
                            value={market}
                            control={<Radio />}
                        />
                    ))}
                </RadioGroup>
                <div className={classes.marketButtons}>
                    <Button onClick={LeftPanelShowToggle}>{t('cancel')}</Button>
                    <Button
                        style={{ background: '#0071dc', color: 'white', borderRadius: '5px' }}
                        variant="contained"
                        onClick={() => setCurrentSelectedMarket(marketChosen)}
                    >
                        {t('apply')}
                    </Button>
                </div>
            </FormControl>
        );
    } else return null;
};

export default MarketSelector;
